import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import RTE from 'react-rte';
import IconButton from 'material-ui/IconButton';
import Close from 'material-ui/svg-icons/navigation/close';
import MenuItem from 'material-ui/MenuItem';
import { Trans, withTranslation } from 'react-i18next';
import FormatAlignLeft from 'material-ui/svg-icons/editor/format-align-left';
import FormatAlignCenter from 'material-ui/svg-icons/editor/format-align-center';
import FormatAlignRight from 'material-ui/svg-icons/editor/format-align-right';
import FormatAlignJustified from 'material-ui/svg-icons/editor/format-align-justify';

import Container from '../../../../app/components/container';
import SelectField from '../../../../app/components/selectField';
import TextField from '../../../../app/components/textField';
import { CircularProgress } from '../../../../app/components/progress';
import { FlatButton } from '../../../../app/components/buttons';

import { getAppUrl } from '../../../../utils/appDetails';
import Select from '@material-ui/core/Select';
import { whatsappMessageChange } from '../../actions';

class ShareWhatsappForm extends Component {
  static propTypes = {
    open: PropTypes.bool.isRequired,
    pending: PropTypes.bool.isRequired,
    whatsappMessage: PropTypes.object.isRequired,
    subject: PropTypes.object.isRequired,
    mode: PropTypes.string.isRequired,
    smsCredit: PropTypes.number.isRequired,
    match: PropTypes.object.isRequired,
    whatsappMessageOptions: PropTypes.array.isRequired,
    openDistributeDialog: PropTypes.func.isRequired,
    closeDistributeDialog: PropTypes.func.isRequired,
    onMessageChange: PropTypes.func.isRequired,
    onSubjectChange: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    setDefaultMessage: PropTypes.func.isRequired,
    onAddContact: PropTypes.func.isRequired,
    onSendWhatsapp: PropTypes.func.isRequired,
    location: PropTypes.object.isRequired,
    organisation: PropTypes.object.isRequired,
    customDomain: PropTypes.object,
    selected: PropTypes.number,
  };

  static defaultProps = {
    selected: 0,
    customDomain: {},
    align: 'left',
  };

  state = {
    value: RTE.createValueFromString(this.props.message.value, 'html'),
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.message.value !== this.stringVal) {
      this.setState({
        value: RTE.createValueFromString(this.props.message.value, 'html'),
      });
    }
  }

  handleChange = value => {
    this.setState({ value }, () => {
      this.stringVal = value.toString('html');

      this.props.onMessageChange(this.stringVal);
    });
  };
  handleAlign = align => {
    this.setState({ align }, () => {
      this.props.onMessageChange(
        `<div style="text-align: ${align}">${this.props.message.value}</div>`,
      );
    });
  };

  render() {
    const {
      closeDistributeDialog,
      whatsappMessage,
      subject,
      whatsappMessageOptions,
      onMessageChange,
      onSubjectChange,
      selected,
      pending,
      onSendWhatsapp,
      customDomain,
      onWhatsappMessageChange,
      t,
    } = this.props;

    return (
      <div className="contacts-form share-email-form">
        <h5>
          <Trans>Distribute to Selected Contacts</Trans>
        </h5>
        <div className="modal-controls-container">
          <IconButton onClick={() => closeDistributeDialog(customDomain)}>
            <Close />
          </IconButton>
        </div>

        <Container>
          <SelectField
            {...whatsappMessage}
            className="offset-top"
            label={t('Select Message')}
            options={whatsappMessageOptions.map(messageOpt => (
              <MenuItem
                key={messageOpt.index}
                value={messageOpt}
                primaryText={messageOpt.value}
              />
            ))}
            onChange={(i, payload) => onWhatsappMessageChange(payload)}
            disabled={whatsappMessageOptions.length === 0}
            autoWidth
          />
        </Container>
        <p className="confirmation-message">
          <Trans>Share with</Trans> <strong>{selected}</strong>&nbsp;{' '}
          {selected > 1 ? t('selected contacts') : t('selected contact')}{' '}
          <Trans>by Whatsapp</Trans>
        </p>
        <Container>
          {pending && <CircularProgress size={18} />}
          {!pending && (
            <FlatButton
              label={t('Confirm')}
              onClick={onSendWhatsapp}
              style={{
                margin: 12,
              }}
              disabled={!whatsappMessage.value}
              primary
            />
          )}
        </Container>
      </div>
    );
  }
}

export default withTranslation()(withRouter(ShareWhatsappForm));
